<template>
  <div>
    <el-table :data="zoneStateList" border size="small" style="width: 1301px">
      <el-table-column prop="zoneId" label="ID" align="center" width="70">
      </el-table-column>

      <el-table-column prop="name" label="名称" align="center" width="120">
      </el-table-column>

      <el-table-column label="对外可见" align="center" width="70">
        <template slot-scope="scope">
          <span>{{ scope.row.isVisible ? "✔️" : "❌️" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="对外状态" align="center" width="70">
        <template slot-scope="scope">
          <span
            v-if="scope.row.status == 1"
            class="zone-status-tag zone-status-tag-maintained"
            >维护</span
          >
          <span
            v-else-if="scope.row.status == 2"
            class="zone-status-tag zone-status-tag-idle"
            >流畅</span
          >
          <span
            v-else-if="scope.row.status == 3"
            class="zone-status-tag zone-status-tag-full"
            >爆满</span
          >
        </template>
      </el-table-column>

      <el-table-column prop="isHealth" label="健康" align="center" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.isHealth">
            <i
              class="el-icon-round"
              style="
                background-color: rgb(73, 243, 73);
                margin-right: 3px;
                border: 1px solid rgb(27, 4, 14);
              "
            ></i>
          </span>
          <span v-else>
            <i
              class="el-icon-round"
              style="
                background-color: rgb(255, 65, 65);
                margin-right: 3px;
                border: 1px solid rgb(27, 4, 14);
              "
            ></i>
          </span>
        </template>
      </el-table-column>

      <el-table-column align="center" width="100">
        <template slot="header">
          <span>名义开服日期</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                某些活动（比如各种“开服活动”）会被配置为相对该日期来算第几天开始和结束
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ $util.ms2day(scope.row.openAt) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="numberOfPlayer"
        label="人数"
        align="center"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="numberOfPlayerOnline"
        label="在线人数"
        align="center"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="numberOfPlayerPay"
        label="付费人数"
        align="center"
        width="80"
      >
      </el-table-column>

      <el-table-column label="付费率(%)" align="center" width="80">
        <template slot-scope="scope">
          <span>{{
            scope.row.numberOfPlayer > 0
              ? (
                  (scope.row.numberOfPlayerPay / scope.row.numberOfPlayer) *
                  100
                ).toFixed(2)
              : 0
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="付费金额(元)"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.totalPaidPriceCents / 100).toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="numberOfGreyList"
        label="灰名单人数"
        align="center"
        width="90"
      >
      </el-table-column>
      <el-table-column
        prop="numberOfBlackList"
        label="黑名单人数"
        align="center"
        width="90"
      >
      </el-table-column>
      <el-table-column label="累充最先抵达玩家" align="center" width="120">
        <template slot-scope="scope">
          <span
            @click="openQueryTheFirstPlayerOfCostXYuanDialog(scope.row)"
            class="link-button"
            >查看</span
          >
        </template>
      </el-table-column>

      <el-table-column label="排行榜" align="center" width="80">
        <template slot-scope="scope">
          <span @click="openLeaderboardDialog(scope.row)" class="link-button"
            >查看</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data() {
    return {
      zoneStateList: [], // 分区状态列表
    };
  },

  async created() {
    this.loadZoneStateList();
  },

  components: {},

  methods: {
    /**
     * 查询分区状态集合
     */
    async loadZoneStateList() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/getZoneState`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      // 排序（按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return y.zoneId - x.zoneId;
      });

      this.zoneStateList = listInResponse;
    },

    /**
     * 打开排行榜对话框
     * @param {} entry
     */
    openLeaderboardDialog(entry) {
      this.$dialogutil.open("LeaderboardDialog", {
        closedCallback: null,
        data: { zoneId: entry.zoneId },
      });
    },

    /**
     * 打开查询累充最先抵达玩家对话框
     * @param {} entry
     */
    openQueryTheFirstPlayerOfCostXYuanDialog(entry) {
      this.$dialogutil.open("QueryTheFirstPlayerOfCostXYuanDialog", {
        closedCallback: null,
        data: { zoneId: entry.zoneId },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>